// extracted by mini-css-extract-plugin
export var isBare = "Lkj1u";
export var isGhost = "YYQtj";
export var isPrimary = "_2DP2X";
export var isSecondary = "_62tPZ";
export var main = "a9dNC";